import * as React from "react";
import { useNavigate } from "react-router-dom";

import Textfield from "../../Components/Textfield";
import Button from "../../Components/Button";

import axiosInstance from "../../Api/Axios";

import { useToast } from "../../Context/ToastContext";
import { useLoader } from "../../Context/LoaderContext";
import { useConnectedUser } from "../../Context/ConnectedUserContext";

const initialFormState = {
  operation: "update_password",
  otp_code: "",
};

const OtpCODE = () => {
  const [valRegister, setValRegister] = React.useState(initialFormState);
  const [formErrorMessage, setFormErrorMessage] = React.useState("");

  const navigate = useNavigate();
  const { addToast } = useToast();
  const { setIsLoading } = useLoader();
  const { updateisFirstTimeConnect } = useConnectedUser();

  const handleChangeField = (e, key) => {
    let errorMessage = "";
    if (key === "registration_number") {
      const regex = new RegExp("^[A-Z0-9]+$");
      if (!regex.test(e.target.value)) {
        errorMessage =
          "Veuillez saisir uniquement des lettres majuscules et des chiffres.";
      }
    }

    setFormErrorMessage((prev) => ({
      ...prev,
      [key]: errorMessage,
    }));

    setValRegister((prev) => ({
      ...prev,
      [key]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    axiosInstance
      .post(`${process.env.REACT_APP_API_URL}/client/check-otp`, {
        otp_code: valRegister.otp_code,
        operation: valRegister.operation,
      })
      .then((response) => {
        setIsLoading(false);

        if (response.data.status) {
          updateisFirstTimeConnect(false);
          navigate("/");
          addToast({
            variant: "success",
            message: response.data.message,
          });
        }
      })
      .catch((error) => {
        setIsLoading(false);

        if (error.response.data.errors) {
          setFormErrorMessage(error.response.data.errors);
        } else {
          addToast({
            variant: "danger",
            message: error.response.data.data || error.response.data.message,
          });
        }
      });
  };

  const hundleResendOtp = () => {
    setIsLoading(true);
    const keyOp = localStorage.getItem("key_op");
    axiosInstance
      .post(`${process.env.REACT_APP_API_URL}/client/resend-otp`, {
        key_op: keyOp,
        operation: valRegister.operation,
      })
      .then((response) => {
        setIsLoading(false);

        if (response.data.status) {
          addToast({
            variant: "success",
            message: response.data.message,
          });
        }
      })
      .catch((error) => {
        setIsLoading(false);

        if (error.response.data.errors) {
          setFormErrorMessage(error.response.data.errors);
        } else {
          addToast({
            variant: "danger",
            message: error.response.data.data || error.response.data.message,
          });
        }
      });
  };

  return (
    <div>
      <h1>Modifier mot de passe</h1>
      <p>Veuillez remplir les champs ci dessous</p>
      <form className="register-form" onSubmit={handleSubmit} noValidate>
        <Textfield
          autoComplete="off"
          label="Code OTP"
          name="otp_code"
          type="text"
          maxLength="6"
          pattern="\d{6}"
          onChange={(e) => handleChangeField(e, "otp_code")}
          placeholder="Veuillez insérer le code reçu par SMS"
          value={valRegister.otp_code}
          hasError={formErrorMessage.otp_code}
          errorMessage={
            formErrorMessage.otp_code && (
              <div className="text-danger">{formErrorMessage.otp_code}</div>
            )
          }
        />

        <div
          className="wrap_actions_form"
          style={{ "justify-content": "flex-start" }}
        >
          <Button type="submit" size="lg">
            Valider
          </Button>
          <Button
            type="button"
            variant="dark"
            view="outline"
            onClick={hundleResendOtp}
          >
            Renvoyer le code
          </Button>
        </div>
      </form>
    </div>
  );
};

export default OtpCODE;
